import React from "react";
import { AutoForm, ErrorsField } from "uniforms-semantic";
import { ModalComponent, ModalActions } from "/imports/client/components/modals";
import FileUpload from "/imports/client/components/forms/input/FileUpload";
import { initJSONschema } from "/imports/utils/UI/initJSONschema";

interface ISchema {
  file: String;
}

const schema = initJSONschema<ISchema>({
  type: "object",
  properties: {
    file: {
      type: "string"
    }
  },
  required: ["file"],
  additionalProperties: false
});

let formRef;
const FileForm = ({ onSubmitForm }) => (
  <AutoForm
    schema={schema}
    modelTransform={(mode, model) => {
      if (mode === "validate") {
        const { name } = model.file || {};

        return {
          ...model,
          file: name
        };
      }
      return model;
    }}
    onSubmit={onSubmitForm}
    ref={ref => {
      formRef = ref;
    }}
  >
    <FileUpload name="file" />
    <ErrorsField />
  </AutoForm>
);

const DocumentModal = ({ show, showModal, title, ...props }) => {
  return (
    <ModalComponent
      title={title}
      show={show}
      showModal={showModal}
      body={<FileForm {...props} />}
      actions={
        <ModalActions
          {...{
            showModal,
            onSave: () => formRef.submit()
          }}
        />
      }
    />
  );
};

export default DocumentModal;
